import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.communication_central.breadcrumb.central_label1'),
  },
];
